module.exports = __webpack_public_path__ + "static/media/icon-moduleE3.5c401891.png";